"use client";

import { useState, type ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { OverlayRegistryProvider } from "@/lib/debug/overlay-registry";

import { DebugPanel } from "./debug-panel";

interface DebugProviderProps {
  children: ReactNode;
}

export function DebugProvider({ children }: DebugProviderProps) {
  const [debugQueryClient] = useState(() => new QueryClient());
  const enabled =
    process.env.NODE_ENV !== "production" &&
    process.env.NEXT_PUBLIC_DEBUG_PANEL !== "off";

  return (
    <OverlayRegistryProvider>
      {children}
      {enabled ? (
        <QueryClientProvider client={debugQueryClient}>
          <DebugPanel />
        </QueryClientProvider>
      ) : null}
    </OverlayRegistryProvider>
  );
}
